import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Instagram, Youtube, Mail, Phone, Clock } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  const quickLinks = [
    { path: '/about', label: t('nav.about') },
    { path: '/mission', label: t('nav.mission') },
    { path: '/breeders', label: t('nav.breeders') },
    { path: '/standard', label: t('nav.standard') },
    { path: '/events', label: t('nav.events') },
    { path: '/contact', label: t('nav.contact') }
  ];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_f40446d8-d7d2-4086-ac19-be3f085557d2/artifacts/2lbvgq55_Cane%20Corso%20Logo-05.png" 
                alt="Cane Corso Logo" 
                className="h-12 w-12 object-contain"
              />
              <div>
                <div className="text-white font-bold">CANE CORSO</div>
                <div className="text-red-500 text-sm">IRK DERNEĞİ</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-red-500 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('nav.contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <Mail size={16} className="mt-1 flex-shrink-0 text-red-500" />
                <span>info@canecorsoturkey.org</span>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <Phone size={16} className="mt-1 flex-shrink-0 text-red-500" />
                <span>www.canecorsoturkey.org</span>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <Clock size={16} className="mt-1 flex-shrink-0 text-red-500" />
                <div>
                  <div>{t('contact.info.weekdays')}</div>
                  <div>{t('contact.info.weekends')}</div>
                </div>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.followUs')}</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/CcClubTurkey"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-gray-800 rounded-full hover:bg-red-600 transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://instagram.com/canecorsoturkiye"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-gray-800 rounded-full hover:bg-red-600 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://youtube.com/@turkiyecanecorsoirkdernegi"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-gray-800 rounded-full hover:bg-red-600 transition-colors"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>{t('footer.copyright')}</p>
          <p className="mt-2 text-gray-500">{t('footer.workingHours')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
